<template>
  <div class="about">    
    <br />
    <br />
    <div class="pheadcontainer">
      <span class="phead">Our vision</span>
    </div>
    <hr />
    <p class="desc">
      We envisage having a high-school students community that has the opportunity to experience<br />high 
      school club activities daily.
    </p>
    <p class="desc-mobile">
      We envisage having a high-school students community that has the opportunity to experience high 
      school club activities daily.
    </p>
    <br />
    <br />
    <div class="pheadcontainer">
      <span class="phead">Our mission</span>
    </div>
    <hr />
    <p class="desc">
      High-School clubs to be a safe place for students with varying interests to come and experience the joy<br />of 
      activities and interests together. Students in India don't have the experience of school club activities<br />and
      our mission through our experience is to help students engage in these fruitfully, to provide<br />all
      high-school students from India the experience of their lifetime.
    </p>
    <p class="desc-mobile">
      High-School clubs to be a safe place for students with varying interests to come and experience the joy of 
      activities and interests together. Students in India don't have the experience of school club activities and
      our mission through our experience is to help students engage in these fruitfully, to provide all
      high-school students from India the experience of their lifetime.
    </p>
    <br />
    <br />
    <div class="pheadcontainer">
      <span class="phead">Contact us</span>
    </div>
    <hr />
    <p>
      You can contact us at: <a target="_blank" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=theartofconnectingstudents@gmail.com">theartofconnectingstudents@gmail.com</a>.<br />
      We hope to provide all students with a fruitful experience.
      
    </p>
  </div>
</template>
<script>
export default {
  mounted(){
    window.scrollTo({top: 0, behavior: "smooth"});
  }
}
</script>

<style scoped>
  .desc-mobile {
    display: none;
  }
  
  @media screen and (max-width: 750px) {
    .pheadcontainer {
      text-align: center;
    }

    .aboutcontainer {
      flex-direction: column;
    }

    .founderpic {
      width: 100%;
    }

    .desc {
      display: none;
    }

    .desc-mobile {
      display: block;
    }
  }
</style>